import { z } from "zod";
import { RequestParameterSectionDtoSchema } from "./RequestParameterSectionDto";

export const RequestTypeStepDtoSchema = z.object({
    name: z.string().nullish(),
    description: z.string().nullish(),
    requestTypeId: z.number(),
    sections: RequestParameterSectionDtoSchema.array(),
});

export type RequestTypeStepDto = z.infer<typeof RequestTypeStepDtoSchema>;